import { Permission } from '../common'

function includesAny(input: string, stringsToMatch: string[]): boolean {
  for (const stringToMatch of stringsToMatch) {
    if (input.includes(stringToMatch)) {
      return true
    }
  }
  return false
}

export const stringToPermissions = (permissionString: string): Permission[] => {
  const permissions = new Set<Permission>()
  if (includesAny(permissionString, ['Read', 'FullAccess'])) {
    permissions.add(Permission.READ)
  }
  if (includesAny(permissionString, ['Edit', 'Write', 'FullAccess'])) {
    permissions.add(Permission.EDIT)
  }
  if (includesAny(permissionString, ['Delete', 'FullAccess'])) {
    permissions.add(Permission.DELETE)
  }
  if (includesAny(permissionString, ['Authorize', 'FullAccess'])) {
    permissions.add(Permission.AUTHORIZE)
  }
  return Array.from(permissions)
}